import { render } from "./App.vue?vue&type=template&id=43d0c875"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=43d0c875&lang=css"

import exportComponent from "C:\\Users\\lv2353\\workspace\\5160-ited\\collection-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__